import type { FC } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import WWOTrafficTopCountries from "app/pages/website-performance/components/TopCountries/WWOTrafficTopCountries";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const WWOTrafficTopCountriesContainerDS: FC = () => {
    const { params } = useCurrentStateAndParams();

    const getCtaLink = () => {
        return {
            href: proNavigator.href("digitalsuite_website_geography", params),
            target: "_self",
        };
    };
    return (
        <WWOTrafficTopCountries
            getCtaLink={getCtaLink}
            params={params}
            unlockHook={{
                component: "WebGeography",
                hookModal: "audienceOverview",
            }}
        />
    );
};
